"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));
var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));
var _ErrorLog = _interopRequireDefault(require("@/components/ErrorLog"));
var _Screenfull = _interopRequireDefault(require("@/components/Screenfull"));
var _SizeSelect = _interopRequireDefault(require("@/components/SizeSelect"));
var _store = _interopRequireDefault(require("@/store"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _user = _interopRequireDefault(require("@/store/modules/user"));
var _settings = require("@/settings");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Breadcrumb: _Breadcrumb.default,
    Hamburger: _Hamburger.default,
    ErrorLog: _ErrorLog.default,
    Screenfull: _Screenfull.default,
    SizeSelect: _SizeSelect.default
  },
  data: function data() {
    return {
      version: _settings.version,
      avatar: "",
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA
    };
  },
  mounted: function mounted() {
    this.avatar = _store.default.getters.info.avatar;
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["sidebar", "device"])),
  methods: {
    changeLange: function changeLange(lang) {
      _jsCookie.default.set("language", lang);
      window.location.reload();
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    logout: function logout() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var userStore;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              userStore = (0, _vuexModuleDecorators.getModule)(_user.default, _this.$store);
              _context.next = 3;
              return userStore.logout();
            case 3:
              _this.$router.push("/login?redirect=".concat(_this.$route.fullPath));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};